export default "__VITE_ASSET__7e85f4ab__"